var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"primary","disabled":!_vm.items.length},on:{"click":_vm.exportData}},[_c('i',{staticClass:"text-white fas fa-file-excel "}),_vm._v(" Exportar Excel ")])}
var staticRenderFns = []

export { render, staticRenderFns }